module.exports = __webpack_public_path__ + "static/media/German_Flag.40d25f9b.png";